<template>
  <div class="app-container">
    <!-- 升级礼包筛选条件 -->
    <el-card class="box-card" v-if="giftType === 'registration'">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单号：">
            <el-input v-model="query.ordernum" placeholder="请输入订单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.name" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="是否使用：">
            <el-select v-model="query.isUse" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 充值礼包筛选条件 -->
    <el-card class="box-card" v-if="giftType === 'recharge'">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单号：">
            <el-input v-model="query.orderNoGoods" placeholder="请输入订单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.userRealName" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.userMobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="赠品状态：">
            <el-select v-model="query.giftStatus" placeholder="请选择" clearable size="small">
              <el-option label="记录" :value="0"></el-option>
              <el-option label="已加入订单" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="createdTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              @change="handleTimeRangeChange"
            />
          </el-form-item>
          <el-form-item label="时间排序：">
            <el-select v-model="query.createdTimeSortSign" placeholder="请选择" clearable size="small">
              <el-option label="升序" :value="1"></el-option>
              <el-option label="降序" :value="-1"></el-option>
              <el-option label="不排序" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right; margin-bottom: 10px;">
        <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button>
      </div>
      <!-- Tab标签页 -->
      <div class="status-tabs mb10">
        <el-tabs v-model="giftType" @tab-click="handleTypeChange">
          <el-tab-pane label="升级礼包" name="registration"></el-tab-pane>
          <el-tab-pane label="充值礼包" name="recharge"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 升级礼包表格 -->
      <el-table v-if="giftType === 'registration'" v-loading="listLoading" :data="list" fit>
        <el-table-column prop="ordernum" label="订单号" min-width="150" />
        <el-table-column prop="name" label="顾客信息" min-width="150" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name}}-{{row.pho}}({{row.levelName}}) </span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="goodsCount" label="商品数量" min-width="100" align="center" />
        <el-table-column prop="isUse" label="是否使用" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isUse === 1 || row.isUse === '1' ? '是' : (row.isUse === 0 || row.isUse === '0' ? '否' : row.isUse) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="发送时间" min-width="160" />
      </el-table>
      <!-- 充值礼包表格 -->
      <el-table v-if="giftType === 'recharge'" v-loading="listLoading" :data="list" fit>
        <el-table-column label="充值订单号" min-width="150">
          <template slot-scope="{ row }">
            <span>{{ row.orderInfoRecharge && row.orderInfoRecharge.orderNumber || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品订单号" min-width="150">
          <template slot-scope="{ row }">
            <span>{{ row.orderInfo && row.orderInfo.orderNum || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="顾客信息" min-width="150" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userRealName || '-' }}-{{ row.userMobile || '-' }}({{ row.userLevelName || '-' }})</span>
          </template>
        </el-table-column>
        <el-table-column label="是否有默认地址" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userIsSetDefaultAddress?"是":"否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否实名认证" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userIsCertificates?"是":"否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.goodsInfo && row.goodsInfo.name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="giftNum" label="商品数量" min-width="100" align="center" />
        <el-table-column prop="giftStatus" label="赠品状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.giftStatus === 1 || row.giftStatus === '1' ? '生成赠品订单' : (row.giftStatus === 0 || row.giftStatus === '0' ? '未生成赠品订单' : row.giftStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="160" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>
<script>
import customerRegistrationApi from '@/api/cust/customerRegistration'
import goodsOrderApi from '@/api/order/goodsOrder'
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      giftType: 'registration', // 礼包类型：registration-升级礼包，recharge-充值礼包
      createdTimeRange: [], // 创建时间范围
      // 直播观看人数导出参数
      exportParams: {
        addrAreaCode: '',
        addrCityCode: '',
        addrProvinceCode: '',
        liveId: 0
      },
      query: {
        pageNo: 1,
        pageSize: 10,
        // 升级礼包参数
        ordernum: undefined,
        name: undefined,
        pho: undefined,
        isUse: undefined,
        // 充值礼包参数
        orderNoGoods: undefined,
        userRealName: undefined,
        userMobile: undefined,
        giftStatus: undefined,
        createdTimeStart: undefined,
        createdTimeEnd: undefined,
        createdTimeSortSign: undefined
      }
    }
  },
  created() {
    // 从路由参数获取直播观看人数导出参数
    if (this.$route.query.liveId) {
      this.exportParams = {
        addrAreaCode: this.$route.query.addrAreaCode || '',
        addrCityCode: this.$route.query.addrCityCode || '',
        addrProvinceCode: this.$route.query.addrProvinceCode || '',
        liveId: parseInt(this.$route.query.liveId) || 0
      }
    }
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 类型切换
     */
    handleTypeChange(tab) {
      // 重置查询条件和数据
      this.handleFilter()
    },
    /**
     * 时间范围变化
     */
    handleTimeRangeChange(val) {
      if (val && val.length === 2) {
        this.query.createdTimeStart = val[0]
        this.query.createdTimeEnd = val[1]
      } else {
        this.query.createdTimeStart = undefined
        this.query.createdTimeEnd = undefined
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 重置搜索条件
     */
    handleFilter() {
      if (this.giftType === 'registration') {
        // 升级礼包参数
        this.query = {
          pageNo: 1,
          pageSize: 10,
          ordernum: undefined,
          name: undefined,
          pho: undefined,
          isUse: undefined,
          // 充值礼包参数重置
          orderNoGoods: undefined,
          userRealName: undefined,
          userMobile: undefined,
          giftStatus: undefined,
          createdTimeStart: undefined,
          createdTimeEnd: undefined,
          createdTimeSortSign: undefined
        }
      } else {
        // 充值礼包参数
        this.query = {
          pageNo: 1,
          pageSize: 10,
          // 升级礼包参数重置
          ordernum: undefined,
          name: undefined,
          pho: undefined,
          isUse: undefined,
          // 充值礼包参数
          orderNoGoods: undefined,
          userRealName: undefined,
          userMobile: undefined,
          giftStatus: undefined,
          createdTimeStart: undefined,
          createdTimeEnd: undefined,
          createdTimeSortSign: undefined
        }
      }
      this.createdTimeRange = []
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      
      // 根据类型调用不同的接口
      const apiCall = this.giftType === 'registration' 
        ? customerRegistrationApi.registrationGiftList(this.query)
        : goodsOrderApi.rechargeGiftRecordList(this.query)
      
      return apiCall
        .then(data => {
          this.list = data.data.list || []
          this.total = data.data.total || 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 导出
     */
    handleExport() {
      // 如果有 liveId 参数，说明是直播观看人数导出
      if (this.exportParams.liveId) {
        // 准备导出参数（使用路由传递的参数）
        const exportParams = {
          addrAreaCode: this.exportParams.addrAreaCode || '',
          addrCityCode: this.exportParams.addrCityCode || '',
          addrProvinceCode: this.exportParams.addrProvinceCode || '',
          liveId: this.exportParams.liveId || 0
        }
        
        // 调用直播观看人数导出接口
        liveManageApi.downloadStatisticsByLive(exportParams)
          .then(response => {
            if (response.code === '0' && response.data && response.data.code) {
              // 获取任务code，跳转到导出页面
              this.$router.push({
                path: '/export/list',
                query: {
                  code: response.data.code
                }
              })
              this.$message.success('导出任务已创建，正在跳转到下载页面')
            } else {
              this.$message.error('导出失败：' + (response.msg || '未获取到任务代码'))
            }
          })
          .catch(error => {
            console.error('导出任务创建失败:', error)
            this.$message.error('导出任务创建失败：' + (error.message || '未知错误'))
          })
      } else {
        // 根据类型跳转到不同的导出页面
        if (this.giftType === 'registration') {
          // 升级礼包导出
          this.$router.push("/export/list?code=registrationGiftExport")
        } else {
          // 充值礼包导出
          this.$router.push("/export/list?code=EEForRechargeGift")
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-container .el-input__inner {
  width: 200px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.status-tabs {
  margin-bottom: 10px;
  
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  
  ::v-deep .el-tabs__nav-wrap {
    padding: 0;
  }
  
  ::v-deep .el-tabs__item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  
  ::v-deep .el-tabs__item.is-active {
    color: #409EFF;
    font-weight: 500;
  }
}
</style>

